import React from 'react';

export const vendorChargeConfig = [
  
  {
    path: '/charge-transport',
    component: React.lazy(() => import('./dendaPengangkutan/index')),
  },
  {
    path: '/charge-transport/detail',
    component: React.lazy(() => import('./detailPengangkutan/index')),
  },
  {
    path: '/charge-sortation',
    component: React.lazy(() => import('./dendaSortasi/index')),
  },
  {
    path: '/charge-sortation/detail',
    component: React.lazy(() => import('./detailSortasi/index')),
  },
];
